module.exports = __webpack_public_path__ + "static/media/8-1.5a42522b.svg";